import { toast } from 'react-toastify';

import { ToastifyProps } from './types';

export default function Toastify({ message, type }: ToastifyProps) {
    return type ? toast[type](message) : toast(message);
}